import { assemblyPages, assemblyText } from './assemblyPages';
/* Public metadata allowlist. Never derive URLs or schema from customer input. */
const SITE_ORIGIN = 'https://xavierassembly.com';
const SITE_NAME = 'Xavier Assembly';
const LOGO = 'https://customer-assets.emergentagent.com/job_assembler-showcase/artifacts/w52bh8fv_Logo%20sem%20Fundo.png';
const PRIVATE_ROBOTS = 'noindex, nofollow, nosnippet';
const INDEX_ROBOTS = 'index, follow, max-image-preview:large';
const PUBLIC_PAGES = {
  '/': {
    title: 'Gazebo & Pergola Installation | Xavier Assembly',
    description: 'Gazebo, pergola and outdoor structure installation quotes from anywhere in the U.S. Verified models get an automatic quote; other models are reviewed manually and our team confirms local installation availability.',
    label: 'Home', service: 'Gazebo and pergola installation', h1: 'Gazebo & Pergola Installation Across the U.S.',
  },
  '/gazebo-installer': {
    title: 'Gazebo Installation Quote Requests Nationwide | Xavier Assembly',
    description: 'Request a gazebo installation quote from anywhere in the U.S. Share your model, ZIP and site details; our team confirms local installation availability.',
    label: 'Gazebo Installation', service: 'Gazebo installation',
  },
  '/pergola-installer': {
    title: 'Pergola Installation Quote Requests Nationwide | Xavier Assembly',
    description: 'Request a pergola installation quote from anywhere in the U.S. Verified models get an automatic quote; PERGOLUX and BON PERGOLA requests are reviewed manually and our team confirms local installation availability.',
    label: 'Pergola Installation', service: 'Pergola installation',
  },
  '/costco-gazebo-installer': {
    title: 'Costco Gazebo Assembly Quote Requests Nationwide | Xavier Assembly',
    description: 'Request a Costco gazebo assembly quote from anywhere in the U.S. Share your kit model, ZIP and site details; our team confirms local installation availability.',
    label: 'Costco Gazebo Assembly', service: 'Gazebo assembly',
  },
  '/yardistry-installer': {
    title: 'Yardistry Installation Quote Requests Nationwide | Xavier Assembly',
    description: 'Request a Yardistry gazebo or pergola assembly quote from anywhere in the U.S. Share your model and ZIP; our team confirms local installation availability.',
    label: 'Yardistry Installation', service: 'Gazebo and pergola assembly',
  },
};
Object.entries(assemblyPages).forEach(([route, content]) => {
  PUBLIC_PAGES[route] = { title: content.title, description: assemblyText(content.intro), label: assemblyText(content.label), h1: assemblyText(content.h1), service: assemblyText(content.label), assemblyContent: content };
});
// These eight location pages already exist in pages/locations/configs.js.
const LOCATIONS = {
  'bay-area': 'the Bay Area', 'san-jose': 'San Jose', sacramento: 'Sacramento',
  concord: 'Concord', vacaville: 'Vacaville', modesto: 'Modesto',
  'santa-rosa': 'Santa Rosa', reno: 'Reno',
};
Object.entries(LOCATIONS).forEach(([slug, name]) => {
  PUBLIC_PAGES[`/locations/${slug}`] = {
    title: `Gazebo & Pergola Installation in ${name} | Xavier Assembly`,
    description: `Gazebo, pergola and outdoor assembly services in ${name}. Explore Xavier Assembly services and share your project details to request a quote.`,
    label: name === 'the Bay Area' ? 'Bay Area' : name,
  };
});

function publicPageForPath(pathname) {
  // Exact allowlist: unknown, encoded, private and token-bearing paths stay private.
  return Object.prototype.hasOwnProperty.call(PUBLIC_PAGES, pathname) ? PUBLIC_PAGES[pathname] : null;
}

function structuredData(pathname, page) {
  if (!page) return null;
  const canonical = SITE_ORIGIN + pathname;
  const graph = [
    { '@type': 'Organization', '@id': `${SITE_ORIGIN}/#organization`, name: SITE_NAME, url: `${SITE_ORIGIN}/`, logo: LOGO, description: 'Gazebo, pergola and outdoor structure installation. Quote requests accepted from all 50 U.S. states; availability confirmed by ZIP.' },
    { '@type': 'WebSite', '@id': `${SITE_ORIGIN}/#website`, name: SITE_NAME, url: `${SITE_ORIGIN}/`, publisher: { '@id': `${SITE_ORIGIN}/#organization` } },
    { '@type': 'WebPage', '@id': `${canonical}#webpage`, url: canonical, name: page.title, description: page.description, isPartOf: { '@id': `${SITE_ORIGIN}/#website` } },
  ];
  if (pathname !== '/') {
    graph.push({ '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_ORIGIN}/` },
      { '@type': 'ListItem', position: 2, name: page.label, item: canonical },
    ] });
  }
  if (page.service) {
    graph.push({ '@type': 'Service', name: pathname === '/' ? 'Gazebo & Pergola Installation' : page.label, serviceType: page.service, description: page.description, url: canonical, provider: { '@id': `${SITE_ORIGIN}/#organization` } });
  }
  return { '@context': 'https://schema.org', '@graph': graph };
}

function metadataForLocation({ pathname, search = '', origin = '', production = false }) {
  const page = publicPageForPath(pathname);
  // Query-bearing links are deliberately not indexable. No query/hash is copied.
  const indexable = Boolean(page && !search && production && origin === SITE_ORIGIN);
  if (!page) return { title: 'Xavier Assembly', description: '', robots: PRIVATE_ROBOTS, canonical: null, schema: null, image: null, page: null };
  return { ...page, page, canonical: SITE_ORIGIN + pathname, robots: indexable ? INDEX_ROBOTS : PRIVATE_ROBOTS,
    schema: search ? null : structuredData(pathname, page), image: LOGO };
}

export { SITE_ORIGIN, SITE_NAME, LOGO, PRIVATE_ROBOTS, INDEX_ROBOTS, PUBLIC_PAGES, publicPageForPath, structuredData, metadataForLocation };
